module.exports = __webpack_public_path__ + "static/media/Mycenaean_icon_200px.251fc3e7.png";